"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var appSettingRouter = {
  path: '/appSetting',
  component: _layout.default,
  redirect: '/appSetting/publicAccount/wxReply/follow',
  name: 'appSetting',
  meta: {
    title: '应用',
    icon: 'clipboard'
  },
  children: [{
    path: 'publicAccount',
    name: 'publicAccount',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/appSetting/wxAccount'));
      });
    },
    meta: {
      title: '公众号',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'wxMenus',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/appSetting/wxAccount/wxMenus'));
        });
      },
      name: 'wxMenus',
      meta: {
        title: '微信菜单',
        icon: ''
      }
    }, {
      path: 'wxReply',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/appSetting/wxAccount/reply/index'));
        });
      },
      name: 'wxReply',
      meta: {
        title: '自动回复',
        icon: ''
      },
      redirect: '/appSetting/publicAccount/wxReply/follow',
      children: [{
        path: 'follow',
        component: function component() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/views/appSetting/wxAccount/reply/follow'));
          });
        },
        name: 'wxFollow',
        meta: {
          title: '微信关注回复',
          icon: ''
        }
      }, {
        path: 'keyword',
        component: function component() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/views/appSetting/wxAccount/reply/keyword'));
          });
        },
        name: 'wxKeyword',
        meta: {
          title: '关键字回复',
          icon: ''
        }
      }, {
        path: 'replyIndex',
        component: function component() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/views/appSetting/wxAccount/reply/follow'));
          });
        },
        name: 'wxReplyIndex',
        meta: {
          title: '无效关键词回复',
          icon: ''
        }
      }, {
        path: 'keyword/save/:id?',
        name: 'wechatKeywordAdd',
        meta: {
          title: '关键字添加',
          noCache: true,
          activeMenu: "/appSetting/publicAccount/wxReply/keyword"
        },
        hidden: true,
        component: function component() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/views/appSetting/wxAccount/reply/follow'));
          });
        }
      }]
    }]
  }]
};
var _default = exports.default = appSettingRouter;